(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  if (!customElements.get('mw-mobile-menu')) {
    customElements.define('mw-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-mw-menu-open]');
        this.closeButton = this.querySelector('[data-mw-menu-close]');
        this.trigger.addEventListener('click', () => this.openMenu(), options);
        this.closeButton.addEventListener('click', () => this.closeMenu(), options);
        this.dialog.addEventListener('close', () => this.restorePage(), options);
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeMenu(); }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeMenu();
          }
          if (event.target.closest('a[href]')) this.closeMenu();
        }, options);
        this.querySelectorAll('[data-mw-localization]').forEach((select) => {
          select.addEventListener('change', () => select.form.requestSubmit(), options);
        });
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 990) this.closeMenu();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          if (window.innerWidth >= 990) return;
          const block = Array.from(this.querySelectorAll('[data-mw-block-id]')).find((item) => item.dataset.mwBlockId === event.detail?.blockId);
          if (!block) return;
          this.openMenu();
          const body = this.querySelector('.mw-mobile-menu__body');
          body.scrollTop += block.getBoundingClientRect().top - body.getBoundingClientRect().top - 12;
        }, options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.closeMenu();
        }, options);
      }
      openMenu() {
        if (this.dialog.open || window.innerWidth >= 990) return;
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        this.locked = true;
        document.body.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      closeMenu() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        this.restorePage();
        if (this.isConnected && window.innerWidth < 990) this.trigger.focus({ preventScroll: true });
      }
      restorePage() {
        if (this.locked) {
          document.body.style.overflow = this.previousOverflow;
          this.locked = false;
        }
        this.trigger?.setAttribute('aria-expanded', 'false');
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restorePage();
        this.controller?.abort();
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
